// extracted by mini-css-extract-plugin
export default {"root":"Date-module_root__CQbEU","button":"Date-module_button__GHX1K"};